import { render, staticRenderFns } from "./RemoveItem.vue?vue&type=template&id=0ef6aaee&scoped=true"
import script from "./RemoveItem.vue?vue&type=script&lang=js"
export * from "./RemoveItem.vue?vue&type=script&lang=js"
import style0 from "./RemoveItem.vue?vue&type=style&index=0&id=0ef6aaee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef6aaee",
  null
  
)

export default component.exports